import { useContext } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import { LanguageContext } from "./LanguageContext.js";
import "./DoctorWebsite.css";

const DoctorWebsite = () => {
  const { lang, toggleLanguage } = useContext(LanguageContext);

  const content = {
    tr: {
      title: "Uzm. Dr. Emre Çenesiz",
      subtitle: "Çocuk Sağlığı ve Hastalıkları Uzmanı",
      about:
        "Dr. Emre Çenesiz, 1993 yılında başladığı Uludağ Üniversitesi Tıp Fakültesi'nden 1999 yılında mezun olarak Tıp Doktoru unvanını almıştır. Uzmanlık eğitimini 2000–2005 yılları arasında İstanbul Üniversitesi (Çapa) Tıp Fakültesi’nde tamamlayarak Çocuk Sağlığı ve Hastalıkları Uzmanı olmuştur. Uzmanlık tezini, komplike üriner sistem enfeksiyonlarında etkenlerin dağılımı üzerine yapmıştır. 2005–2014 yılları arasında Özel İstanbul Medicine Hastanesi’nde, 2014–2016 yılları arasında Memorial Hizmet Hastanesi’nde ve 2016–2024 yılları arasında Liv Hospital Ulus Hastanesi’nde görev yapmıştır. 2024 yılından itibaren ise Medicana Zincirlikuyu Hastanesi’nde çalışmalarına devam etmektedir.",
      appointment: "Randevu Al",
      aboutme: "Hakkımda",
      media: "Medya",
      opinion: "Görüşler",
      faq: "İletişim",
      socials: "Bana Ulaş",
    },
    en: {
      title: "Specialist Dr. Emre Çenesiz",
      subtitle: "Pediatric Health and Diseases Specialist",
      about:
        "Dr. Emre Çenesiz graduated from Uludağ University Faculty of Medicine in 1999. He completed his specialization in Pediatrics at Istanbul University (Çapa) Faculty of Medicine between 2000–2005. He worked at Istanbul Medicine Hospital (2005–2014), Memorial Hizmet Hospital (2014–2016), and Liv Hospital Ulus (2016–2024). Since 2024, he has been continuing his career at Medicana Zincirlikuyu Hospital.",
      appointment: "Make an Appointment",
      aboutme: "About Me",
      media: "Media",
      opinion: "Opinions",
      faq: "Contact",
      socials: "Contact Me",
    },
  };

  return (
    <div className="website-wrapper">
      <header className="main-header">
        <div className="header-left">
          <Link to="/">
            <img src="/logo.png" alt="Logo" className="logo" />
          </Link>
        </div>

        <div className="header-center">
          <nav className="nav-links">
            <a href="#about">{content[lang].aboutme}</a>
            <a href="/medya">{content[lang].media}</a>
            <a href="/reviews">{content[lang].opinion}</a>
            <a href="/contact">{content[lang].faq}</a>
          </nav>
          <div className="underline" />
        </div>

        <div className="header-right">
          <button onClick={toggleLanguage} className="lang-btn">
            {lang === "tr" ? "EN" : "TR"}
          </button>
          <a
            href="https://www.medicana.com.tr/online-randevu?d=6g8OSll_QHs=&h=eJTRa8B9u7U=&b=O9z2njYFPJY="
            target="_blank"
            rel="noopener noreferrer"
            className="appointment-btn"
          >
            {content[lang].appointment}
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-image-wrapper">
          <img
            src={"thumb1.jpeg"}
            alt="Uzm. Dr. Emre Çenesiz"
            className="hero-image"
          />
        </div>
        <div className="hero-text">
          <div className="hero-content">
            <h1>
              Uzm. Dr. <br /> Emre Çenesiz
            </h1>
            <p className="hero-subtitle">{content[lang].subtitle}</p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about-section">
        <div className="about-wrapper">
          <h3 className="section-title">
            {lang === "tr" ? "Hakkımda" : "About Me"}
          </h3>
          <p className="about-text">{content[lang].about}</p>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="gallery-section">
        {[1, 2, 3].map((i) => (
          <a
            key={i}
            href={"https://www.instagram.com/dremrecenesiz/"}
            target="_blank"
            rel="noopener noreferrer"
            className="gallery-item"
          >
            <motion.img
              whileHover={{ scale: 1.05 }}
              src={`/foto${i}.jpeg`}
              alt={`Gallery ${i}`}
              className="gallery-img"
            />
            <img
              src="/cursor.png"
              alt="Click cursor"
              className="cursor-sticker"
            />
          </a>
        ))}
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-block">
            <CountUp end={20} duration={2} />
            <p>{lang === "tr" ? "Yıl" : "Years"}</p>
          </div>
          <div className="stat-block">
            <CountUp end={5000} duration={2} />
            <p>{lang === "tr" ? "Yıllık Hasta" : "Yearly Patients"}</p>
          </div>
          <div className="stat-block">
            <CountUp end={15} duration={2} />
            <p>{lang === "tr" ? "Makale" : "Articles"}</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <h4 className="contact-title">{content[lang].socials}</h4>
        <div className="contact-icons">
          <a
            href="mailto:cenesize@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fas fa-envelope"></i>
          </a>
          <a
            href="https://instagram.com/dremrecenesiz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://bulutklinik.com/dr-ogr-uyesi-emre-cenesiz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              border="0"
              alt="bulut klinik"
              src="bulut_klinik.png"
              width="20"
              height="20"
            />
          </a>
          <a
            href="https://www.doktorsitesi.com/dr-ogr-uyesi-emre-cenesiz/cocuk-sagligi-ve-hastaliklari/istanbul"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              border="0"
              alt="doktor sitesi"
              src="doktor_sitesi.png"
              width="20"
              height="20"
            />
          </a>
        </div>
      </section>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Dr. Emre Çenesiz</p>
      </footer>
    </div>
  );
};

export default DoctorWebsite;
